import { FiExternalLink } from 'react-icons/fi'

import { isSafeHttpHref } from '~/helpers'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import * as S from './styles'

const OpenInNewTab = ({ href, label, className }: OpenInNewTabProps) => {
  const { t } = useAPPTranslation()

  if (!isSafeHttpHref(href)) {
    return null
  }

  const resolvedLabel = label ?? t('c:actions.openInNewTab')

  return (
    <S.OpenInNewTab
      className={className}
      href={href.trim()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="open-in-new-tab"
      aria-label={resolvedLabel}
      title={resolvedLabel}
    >
      <FiExternalLink />
    </S.OpenInNewTab>
  )
}

export default OpenInNewTab
